module.exports = require('./helpers/bundle-url').getBundleURL('13ph5') + "flag_fr.1e72d885.svg";